import React, { FC, useCallback, useMemo } from 'react'
import { Alert } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { split, property } from 'lodash'
import { RootState } from '../types'
import { useDispatch, useSelector } from 'react-redux'
import { companies } from '@bdswiss/common-enums'
import { dismissRiscDisclaimer } from '../actions/commonActions'

const getCompanyDomain = (company: string) =>
  property<typeof companies, string>(`${company}.domain`)(companies)

export const SignalsDisclaimer: FC = () => {
  const [headText, riskText, tailText] = useMemo(() => {
    const [disclaimerHead, disclaimerTail] = split(
      I18n.t('signalsRiskDisclaimer'),
      '%{riskDisclaimer}'
    )
    return [disclaimerHead, I18n.t('riskDisclaimer'), disclaimerTail]
  }, [])

  const company = useSelector<RootState, string>((state) => state.userAccount.viewer.company)
  const riskURL = useMemo(() => {
    return `https://${
      /staging/.test(window.location.hostname)
        ? window.location.hostname.split('.').splice(-2, 2).join('.')
        : getCompanyDomain(company)
      }/general-terms-and-conditions/`
  // }/${company === companies.viverno.value ? 'legal-documents' : 'general-terms-and-conditions'}/`
  }, [company])
  const dispatch = useDispatch()
  const dismiss = useCallback(() => {
    dispatch(dismissRiscDisclaimer())
  }, [dispatch])
  return (
    <Alert className="SignalsRiskDisclaimer">
      <span>
        {headText}
        <a href={riskURL} target="_blank" rel="noopener noreferrer">
          {riskText}
        </a>
        {tailText}
      </span>
      <button onClick={dismiss} className="btn close_btn" data-cy="closeTrade">
        <i className="icon-close-new" />
      </button>
    </Alert>
  )
}
